<div class="load-app">
  <div class="load-app-logo">
    <img [src]="srcLogo" [title]="fantasia" [alt]="fantasia">
    <br>
    Autenticando <div class="dot-flashing"></div>
  </div>
</div>
